import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Switch,
  Typography,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MenuSection from "../components/MenuSection";
import puestos from "../api/puestos";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import TagIcon from "@mui/icons-material/Tag";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import qrs from "../api/qr";
import { useNavigate } from "react-router-dom";
import { guardarTalonarios } from "../helpers/guardarTalonariosHelper";
import apiErrorHandler from "../helpers/apiErrorHandler"; // Importa el helper
import CustomSwitch from "../components/CustomSwitch";
import configuracionIntegracionesFULL from "../api/configuracionIntegracionesFULL";

const ConfiguracionesPage = () => {
  const esKiosk = JSON.parse(localStorage.getItem("esKiosk")) || false;
  const [modalPuestoOpen, setModalPuestoOpen] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [errorDialogMessage, setErrorDialogMessage] = useState("");

  // const [isQRSwitchOn, setIsQRSwitchOn] = useState(() => JSON.parse(localStorage.getItem("isQRSwitchOn")) ?? true);
  const [isQRSwitchOn, setIsQRSwitchOn] = useState(() => {
    const storedSwitchState = JSON.parse(localStorage.getItem("isQRSwitchOn"));
    return storedSwitchState !== null ? storedSwitchState : false; // Default a "false" para LISTA QRS
  });

  const [currentBandera, setCurrentBandera] = useState(() => localStorage.getItem("bandera") || "sinBandera");

  const [modalPrefijoOpen, setModalPrefijoOpen] = useState(false);
  const [prefijo, setPrefijo] = useState(() => localStorage.getItem("prefijoFront") || "");
  const [qrPosition, setQrPosition] = useState("");
  const [selectedPuestoId, setSelectedPuestoId] = useState("");
  const [getPuestos, setGetPuestos] = useState([]);
  const [qrArray, setQRArray] = useState([]);
  const [openResultDialog, setOpenResultDialog] = useState(false);
  const [validationResult, setValidationResult] = useState({ success: false, message: "" });
  const [openSaveDialog, setOpenSaveDialog] = useState(false);
  const [loading, setLoading] = useState(false); // Estado para el indicador de carga
  const theme = useTheme();
  const navigate = useNavigate();
  const nic = localStorage.getItem("formattedNic");
  const [qrArrayLoaded, setQrArrayLoaded] = useState(false); // Nuevo estado para controlar la carga de qrArray
  const bandera = currentBandera;
  const [useTips, setUseTips] = useState(() => JSON.parse(localStorage.getItem("useTips")) ?? false);
  const [useCashback, setUseCashback] = useState(() => JSON.parse(localStorage.getItem("useCashback")) ?? false);

  // estados para el modal de seleccionar bandera
  const [modalBanderaOpen, setModalBanderaOpen] = useState(false);
  const [selectedBandera, setSelectedBandera] = useState(() => localStorage.getItem("bandera") || "");

  useEffect(() => {
    localStorage.setItem("useTips", JSON.stringify(useTips));
    localStorage.setItem("useCashback", JSON.stringify(useCashback));
  }, [useTips, useCashback]);

  const handleSelectChangePuesto = async event => {
    const { value } = event.target;
    console.log(value);

    setSelectedPuestoId(value);
    localStorage.setItem("puesto", JSON.stringify(getPuestos[value]));
    const puesto = JSON.parse(localStorage.getItem("puesto"));
    console.log(puesto);

    const cantidadPlayerosSolicitados = puesto.caja.cantidadPlayerosSolicitados;
    const solicitarAforadores = puesto.caja.solicitarAforadores;
    const perteneceFULL = puesto.talonarios[0].perteneceFULL;
    localStorage.setItem("cantidadPlayerosSolicitados", cantidadPlayerosSolicitados);
    localStorage.setItem("solicitarAforadores", solicitarAforadores);
    localStorage.setItem("idCaja", puesto.caja.idCaja);
    localStorage.setItem("perteneceFULL", perteneceFULL);
    localStorage.setItem("combustiblesSoloPorDespachos", puesto.combustiblesSoloPorDespachos);
    localStorage.setItem("nombreCaja", puesto.caja.descripcion);
    console.log("Cantidad de Playeros Solicitados:", cantidadPlayerosSolicitados);

    const habilitarFacturacionArticulosFullPlaya = await configuracionIntegracionesFULL.getConfiguracionIntegracionesFULL();
    localStorage.setItem("habilitarFacturacionArticulosFullPlaya", habilitarFacturacionArticulosFullPlaya.habilitarFacturacionArticulosFullPlaya);
    const habilitaTiendaFull =
      (bandera === "ypf" || bandera === "sinBandera") && perteneceFULL && (!solicitarAforadores || habilitarFacturacionArticulosFullPlaya.habilitarFacturacionArticulosFullPlaya);
    localStorage.setItem("habilitaTiendaFull", habilitaTiendaFull);
    guardarTalonarios(puesto);
  };

  const handleOpenModalPuesto = async () => {
    setModalPuestoOpen(true);
    setLoading(true);
    try {
      const allPuestos = await puestos.getPuestos();
      setGetPuestos(allPuestos);
      localStorage.setItem("puestosArray", JSON.stringify(allPuestos));
      console.log(JSON.stringify(allPuestos));
    } catch (error) {
      console.log("Ocurrió un error al obtener los puestos:", error);
      apiErrorHandler(error, { stopFlow: true });
    } finally {
      setLoading(false);
    }
  };

  const handleContinuarClick = () => {
    setModalPuestoOpen(false);
  };

  const handlePrefijoChange = event => {
    const inputValue = event.target.value;
    if (/^\d*$/.test(inputValue)) {
      setPrefijo(inputValue);
    }
  };

  const handlePrefijoClick = () => {
    if (prefijo) {
      localStorage.setItem("prefijoFront", prefijo);
      setModalPrefijoOpen(false);
      console.log(localStorage.getItem("prefijoFront"));
    }
  };
  const handleSwitchChange = () => {
    const newSwitchState = !isQRSwitchOn;

    if (!qrArrayLoaded) {
      // Si el switch se cambia a LISTA QRS y no hay listado disponible
      setErrorDialogMessage("No tiene listado de QRs asociados.");
      setOpenErrorDialog(true);
      return;
    }

    setIsQRSwitchOn(newSwitchState);
    localStorage.setItem("isQRSwitchOn", JSON.stringify(newSwitchState));
    if (newSwitchState) {
      console.log("sin listado");
      console.log(qrArray);
      localStorage.setItem("conListadoQR", false);
    } else {
      console.log("con listado");
      localStorage.setItem("conListadoQR", true);
    }
  };

  const handleQrPositionChange = event => {
    setQrPosition(event.target.value);
  };

  const handleValidateClick = () => {
    console.log("QR Position:", qrPosition);
    console.log(qrArray);
    const posicionQR = qrArray.find(qr => qr.posi === +qrPosition);

    if (posicionQR) {
      console.log("el qr fue validado con exito");
      localStorage.setItem("idPosicionQR", posicionQR.posi);
      localStorage.setItem("urlPosicionQR", posicionQR.url);
      setValidationResult({
        success: true,
        message: "El QR fue validado con éxito.",
      });
    } else {
      console.log("el qr no fue validado");
      localStorage.removeItem("idPosicionQR");
      localStorage.removeItem("urlPosicionQR");
      setValidationResult({
        success: false,
        message: "El QR no pudo ser validado. Por favor, verifique la posición ingresada.",
      });
    }

    setOpenResultDialog(true);
    setTimeout(() => setOpenResultDialog(false), 2000);
  };

  useEffect(() => {
    setLoading(true);

    // Obtiene el estado del switch de localStorage si está almacenado
    const storedSwitchState = JSON.parse(localStorage.getItem("isQRSwitchOn"));
    if (storedSwitchState !== null) {
      setIsQRSwitchOn(storedSwitchState);
    }

    // Verifica si hay una posición de QR almacenada en localStorage
    const storedQrPosition = localStorage.getItem("idPosicionQR");
    if (storedQrPosition) {
      setQrPosition(storedQrPosition); // Establece el valor inicial de qrPosition
    }

    fetchQRS();
  }, []);

  const fetchQRS = async () => {
    try {
      const qrsEstacion = await qrs.getQRs();
      const qrsOrdenados = qrsEstacion.sort((a, b) => a.posi - b.posi);
      setQRArray(qrsOrdenados);
      localStorage.setItem("qrsArray", JSON.stringify(qrsOrdenados));
      setQrArrayLoaded(true); // Marca qrArray como cargado exitosamente
    } catch (error) {
      console.error("Error al obtener los datos:", error);
      setQrArrayLoaded(false); // Marca qrArray como no cargado debido al error
      // apiErrorHandler(error, { stopFlow: true });
    }
    setLoading(false);
  };

  const handleGuardar = () => {
    setOpenSaveDialog(true);
    setTimeout(() => {
      setOpenSaveDialog(false);
      navigate(!esKiosk?"/home" : "/tiendakioskpage", {state: { vieneDeDetalles: true, limpiarProductos: true }}); // Navegar a "/home" después de 2 segundos
    }, 2000);
  };

  const handleBanderaChange = event => {
    const newBandera = event.target.value;
    setSelectedBandera(newBandera);
    setCurrentBandera(newBandera);
    localStorage.setItem("bandera", "point");
    window.dispatchEvent(new Event("banderaChanged"));
  };

  const handleBanderaClick = () => {
    if (selectedBandera) {
      setCurrentBandera(selectedBandera);
      localStorage.setItem("bandera", selectedBandera);
      setModalBanderaOpen(false);
      window.location.href = "/home";
    }
  };
  return (
    <>
      <MenuSection />

      {/* Menú con borde */}
      <Box
        sx={{
          mb: 6,
          marginBottom: window.innerWidth < 700 ? 8 : 4,

          p: 2,
          bgcolor: theme.palette.background.paper,
          border: loading ? "none" : "0.5px solid", // Condiciona el borde según el estado de loading
          borderColor: loading ? "transparent" : theme.bandera.colorPrimario, // Asegura que el borde esté transparente cuando loading
          borderRadius: 1,
        }}
      >
        {/* Indicador de carga */}

        <>
          {/* Opciones en columna */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Opción Seleccionar Puesto */}
            <Button
              variant="contained"
              onClick={handleOpenModalPuesto}
              sx={{
                backgroundColor: theme.bandera.colorSecundario,
                color: theme.bandera?.colorTextoBoton,
                width: "100%",
                justifyContent: "flex-start",
                padding: "12px 24px",
                fontSize: "1.2rem",
                minHeight: "56px",
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                  color: theme.bandera?.colorTextoBoton,
                },
              }}
              startIcon={<AddCircleIcon sx={{ fontSize: "2rem" }} />}
            >
              Seleccionar Puesto
            </Button>

            {/* Opción Ingresar Prefijo */}
            <Button
              variant="contained"
              onClick={() => setModalPrefijoOpen(true)}
              sx={{
                marginTop: 2,
                backgroundColor: theme.bandera.colorSecundario,
                color: theme.bandera?.colorTextoBoton,
                width: "100%",
                justifyContent: "flex-start",
                padding: "12px 24px",
                fontSize: "1.2rem",
                minHeight: "56px",
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                  color: theme.bandera?.colorTextoBoton,
                },
              }}
              startIcon={<TagIcon sx={{ fontSize: "2rem" }} />}
            >
              Ingresar Prefijo
            </Button>
            {/* Opción Seleccionar Bandera */}
            {/* <Button
              variant="contained"
              onClick={() => setModalBanderaOpen(true)}
              sx={{
                marginTop: 2,
                backgroundColor: theme.bandera.colorSecundario,
                color: theme.bandera?.colorTextoBoton,
                width: "100%",
                justifyContent: "flex-start",
                padding: "12px 24px",
                fontSize: "1.2rem",
                minHeight: "56px",
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                  color: theme.bandera?.colorTextoBoton,
                },
              }}
              startIcon={<TagIcon sx={{ fontSize: "2rem" }} />}
            >
              Seleccionar Bandera
            </Button> */}
          </Box>
          <Box>
            {/* Switch para PROPINA */}
            <CustomSwitch leftLabel="PROPINA" value={useTips} onChange={() => setUseTips(prev => !prev)} />

            {/* Switch para LISTA QRS / QR INDIVIDUAL */}

            <CustomSwitch leftLabel="CASHBACK" value={useCashback} onChange={() => setUseCashback(prev => !prev)} />
          </Box>
          <FormControl fullWidth sx={{ mt: 2, display: "none" }}>
            <InputLabel id="bandera-visual-select-label">Bandera visual</InputLabel>
            <Select
              labelId="bandera-visual-select-label"
              id="bandera-visual-select"
              value={bandera}
              label="Bandera visual"
              onChange={handleBanderaChange}
            >
              <MenuItem value="sinBandera">Sin bandera</MenuItem>
              <MenuItem value="ypf">Torre YPF</MenuItem>
              <MenuItem value="shell">Shell</MenuItem>
            </Select>
          </FormControl>

          {bandera !== "axion" &&
            (loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100px" }}>
                <CircularProgress sx={{ color: theme.bandera.colorSecundario }} />
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                {isQRSwitchOn && (
                  <>
                    <TextField
                      variant="outlined"
                      placeholder="INGRESE POSICIÓN DE QR"
                      value={qrPosition}
                      onChange={handleQrPositionChange}
                      sx={{ mb: 1, width: "90%" }}
                      type="number"
                      InputProps={{
                        sx: {
                          fontSize: "17px",
                        },
                        inputProps: {
                          style: { textAlign: "center" },
                        },
                      }}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleValidateClick}
                      sx={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        backgroundColor: theme.bandera.colorSecundario,
                        color: theme.bandera?.colorTextoBoton,
                        ":hover": {
                          backgroundColor: theme.bandera.colorSecundario,
                          color: theme.bandera?.colorTextoBoton,
                        },
                      }}
                    >
                      VALIDAR
                    </Button>
                  </>
                )}
              </Box>
            ))}

          {/* Si no está cargado qrArray, no muestra nada */}
        </>
      </Box>

      {/* Modal para agregar prefijo */}
      <Modal open={modalPrefijoOpen} onClose={() => setModalPrefijoOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            width: "250px",
            p: 4,
            borderRadius: 2,
            display: "grid",
            gridTemplateRows: "auto 1fr",
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            Ingrese un prefijo
          </Typography>
          <TextField type="number" value={prefijo} onChange={handlePrefijoChange} placeholder="Solo números" sx={{ height: "1fr" }} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: theme.bandera.colorSecundario,
                color: theme.bandera?.colorTextoBoton,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                  color: theme.bandera?.colorTextoBoton,
                },
              }}
              onClick={handlePrefijoClick}
              disabled={!prefijo}
            >
              Continuar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal para seleccionar puesto */}
      <Modal open={modalPuestoOpen} onClose={() => setModalPuestoOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            width: "250px",
            p: 4,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            Puesto de emisión
          </Typography>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="puesto-select-label">Puestos</InputLabel>
            <Select labelId="puesto-select-label" id="puesto-select" value={selectedPuestoId} label="Puestos" onChange={handleSelectChangePuesto}>
              {getPuestos.map((puesto, index) => (
                <MenuItem key={puesto.nombre} value={index}>
                  {puesto.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: theme.bandera.colorSecundario,
                color: theme.bandera?.colorTextoBoton,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                  color: theme.bandera?.colorTextoBoton,
                },
              }}
              onClick={handleContinuarClick}
            >
              Continuar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal para seleccionar bandera */}
      <Modal open={modalBanderaOpen} onClose={() => setModalBanderaOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            width: "260px",
            p: 4,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            Seleccionar Bandera
          </Typography>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="bandera-select-label">Bandera</InputLabel>
            <Select labelId="bandera-select-label" id="bandera-select" value={selectedBandera} label="Bandera" onChange={handleBanderaChange}>
              <MenuItem value="ypf">YPF</MenuItem>
              <MenuItem value="shell">Shell</MenuItem>
              <MenuItem value="axion">Axion</MenuItem>
              <MenuItem value="puma">Puma</MenuItem>
              <MenuItem value="gulf">Gulf</MenuItem>
              <MenuItem value="refinor">Refinor</MenuItem>
              <MenuItem value="dapsa">Dapsa</MenuItem>
              <MenuItem value="voy">Voy</MenuItem>
            </Select>
          </FormControl>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: theme.bandera.colorSecundario,
                color: theme.bandera?.colorTextoBoton,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                  color: theme.bandera?.colorTextoBoton,
                },
              }}
              onClick={handleBanderaClick}
              disabled={!selectedBandera}
            >
              Continuar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Diálogo de resultado */}
      <Dialog open={openResultDialog} onClose={() => setOpenResultDialog(false)}>
        <DialogContent>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {validationResult.success ? (
              <CheckCircleIcon color="success" style={{ fontSize: 50, marginRight: "10px" }} />
            ) : (
              <ErrorIcon color="error" style={{ fontSize: 50, marginRight: "10px" }} />
            )}
            <Typography fontWeight="bold">{validationResult.message}</Typography>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Diálogo de guardado */}
      <Dialog open={openSaveDialog} onClose={() => setOpenSaveDialog(false)}>
        <DialogContent>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <CheckCircleIcon color="success" style={{ fontSize: 50, marginRight: "10px" }} />
            <Typography fontWeight="bold">Configuraciones guardadas con éxito</Typography>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Botón Guardar */}
      <Button
        variant="contained"
        sx={{
          position: "fixed",
          bottom: 45,
          fontWeight: "bold",
          right: 20,
          backgroundColor: theme.bandera.colorSecundario,
          color: theme.bandera?.colorTextoBoton,
          fontSize: "1.2rem",
          padding: "10px 22px",
          ":hover": {
            backgroundColor: theme.bandera.colorSecundario,
            color: theme.bandera?.colorTextoBoton,
          },
        }}
        onClick={handleGuardar}
      >
        GUARDAR
      </Button>
      <Dialog open={openErrorDialog} onClose={() => setOpenErrorDialog(false)}>
        <DialogContent>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <ErrorIcon color="error" style={{ fontSize: 50, marginRight: "10px" }} />
            <Typography fontWeight="bold">{errorDialogMessage}</Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ConfiguracionesPage;
